import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTheme } from "styled-components";
import InputText from "../../atomic/InputText/InputText";
import TextArea from "../../atomic/TextArea/TextArea";
import RichTextEditor, {
  Converter
} from "../../atomic/RichTextEditor/RichTextEditor";
import Dropdown from "../../atomic/Dropdown/Dropdown";

const RootWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
  padding: 10px;
  border-radius: 8px;
  transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1) 0s;
  background: white;
  margin-bottom: 10px;
`;
const Root = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: rgb(233, 235, 238);
  font-size: 14px;
  padding: 15px;
  label {
    width: 100%;
    color: rgba(0, 0, 0, 0.54);
    display: inline-block;
    font-size: 13px;
    line-height: 20px;
  }
  button {
    background-color: rgb(2, 82, 107);
    color: white;
    cursor: pointer;
    font-size: 12px;
    padding: 5px 10px;
    text-decoration: none;
    min-width: 100px;
    font-weight: 600;
  }
`;

const Buttons = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

const cats = [
  { id: "sport", name: "Sport" },
  { id: "dance", name: "Dance" },
  { id: "education", name: "Education" },
  { id: "swimming", name: "Swimming" },
  { id: "arts", name: "Arts & Performance Arts" },
  { id: "music", name: "Music" }
];

export default withTheme(
  ({
    theme,
    name,
    setName,
    description,
    setDescription,
    website,
    setWebsite,
    email,
    setEmail,
    category,
    setCategory,
    save,
    saving
  }) => {
    const [richTextState, setRichTextState] = useState(
      Converter.convertToState(description || "")
    );
    useEffect(() => {
      setRichTextState(Converter.convertToState(description || ""));
    }, [description]);
    return (
      <RootWrapper>
        <Root>
          <label>Company name</label>
          <InputText
            value={name}
            onChange={e => setName(e.target.value)}
            placeholder="Enter Company Name"
          />
          <label>Category</label>
          <Dropdown
            placeholder={"Choose category"}
            options={cats.map(l => ({ value: l.id, label: l.name }))}
            value={category}
            onChange={l => {
              console.log("Selected", l);
              setCategory(l);
            }}
          />
          <label>Company Description</label>
          <RichTextEditor
            id="LoyalityDetails"
            editorState={richTextState}
            onChange={st => {
              setRichTextState(st);
            }}
          />
          <label>Website</label>
          <InputText
            value={website}
            onChange={e => setWebsite(e.target.value)}
            placeholder="Enter Website"
          />
          <label>Contact email</label>
          <InputText
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="Enter email"
          />
          <Buttons>
            {!saving && (
              <button
                onClick={() => {
                  setDescription(Converter.convertFromState(richTextState));
                  save(Converter.convertFromState(richTextState));
                }}
              >
                Save
              </button>
            )}
            {saving && (
              <button>
                <FontAwesomeIcon
                  icon={["fas", "spinner"]}
                  size="1x"
                  color={"white"}
                  spin
                />
              </button>
            )}
          </Buttons>
        </Root>
      </RootWrapper>
    );
  }
);
